import React, { useState } from "react";

interface ErrorContextType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setError: React.Dispatch<any>;
}

export const ErrorContext = React.createContext({} as ErrorContextType);

interface ErrorProviderProps {
  children: React.ReactNode;
}

export default function ErrorProvider({
  children,
}: ErrorProviderProps): React.JSX.Element {
  const [error, setError] = useState(null);

  if (error) {
    throw error;
  }
  return (
    <ErrorContext.Provider value={{ setError }}>
      {children}
    </ErrorContext.Provider>
  );
}
